// Arbitrary GTM Events to run on load
const EVENTS = [
  { value: 'optimize.activate', isOncePerSession: false }
]

const init = () => {
  let storedEvents = window.sessionStorage.getItem('GTMEvents')
  storedEvents = storedEvents == null ? [] : JSON.parse(storedEvents)

  EVENTS.forEach(event => {
    const _isOncePerSession = event.hasOwnProperty('isOncePerSession') && event.isOncePerSession == true

    // if this should only run once and has been called, cancel it
    if (_isOncePerSession && storedEvents.indexOf(event.value) > -1) return false

     (window.dataLayer || (window.dataLayer = [])).push({ 'event': event.value })

    // Store run notification in should only run once (per session)
    if (_isOncePerSession) window.sessionStorage.setItem('GTMEvents', JSON.stringify(['optimize.activate']))
  })
}

const GtmEvents = { init }
export default GtmEvents




// WEBPACK FOOTER //
// ./js/core/GtmEvents.js